export default Object.freeze({
  // BASE_ENDPOINT: 'http://localhost:5000/'
  //  BASE_ENDPOINT: `https://tr-bf.herokuapp.com`
  // Prod: https://fvsdtk51rg.execute-api.us-east-2.amazonaws.com/bfprod/
  // Dev: https://fvsdtk51rg.execute-api.us-east-2.amazonaws.com/bf/
  // Localhost: http://localhost:5000/
});


export const triggerIdA = 'A';
export const triggerIdU = 'U';

